export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false,
};

export const PageName = '兑换商品列表';
